import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { HelperProvider } from '../helper/helper';
import { UserInfo } from '../../interfaces/user-info.model';
import { WebserviceProvider } from '../webservice/webservice';
import { Action } from '../../interfaces/action.model';

@Injectable()
export class UserInformationProvider {

  userInformation: UserInfo;
  lastSyncDate: string;

  constructor(
    public http: HttpClient, 
    public helperService: HelperProvider, 
    public storage: Storage, 
    public webservice: WebserviceProvider) {
    this.userInformation = null;
  }

  getUserInformation(){
    return new Promise((resolve, reject) => {
      this.userInformation = {
        iPadAppVersion: "",
        lastLogin: "0001-01-01T00:00:00Z",
        lastSynchro: "0001-01-01T00:00:00Z"
      };

      const allPromise = [
        this.getLoginDate().catch(() => {return "0001-01-01T00:00:00Z";}),
        this.getSyncDate().catch(() => {return "0001-01-01T00:00:00Z";}),
        this.getAppVersion().catch(() => {return "";})];

      Promise.all(allPromise)
        .then(values => {
          this.userInformation.lastLogin = values[0];
          if (this.userInformation.lastLogin == null) this.userInformation.lastLogin = "0001-01-01T00:00:00Z";
          this.userInformation.lastSynchro = values[1];
          if (this.userInformation.lastSynchro == null) this.userInformation.lastSynchro = "0001-01-01T00:00:00Z";
          this.userInformation.iPadAppVersion = values[2];
          if (this.userInformation.iPadAppVersion == null) this.userInformation.iPadAppVersion = "";
          resolve(this.userInformation);
        });
        /*.catch(reason => {
          this.userInformation.lastLogin = "0001-01-01T00:00:00Z";
          this.userInformation.lastSynchro = "0001-01-01T00:00:00Z";
          this.userInformation.iPadAppVersion = "";
          reject(this.userInformation);
        });*/
    });
  }

  getLoginDate(){
    return this.storage.get("loginDate");
  }

  getSyncDate(){
    return this.storage.get("syncDate");
  }

  getAppVersion(){
    return this.helperService.getAppVersion();
  }

  setUserInformation(){
    return new Promise((resolve, reject) => {
      this.getUserInformation()
      .then(() => {
        this.webservice.updateUserInfo(this.userInformation)
        .subscribe(res => {
          resolve(res);
        }, error => {
          console.log("Impossible to update user information");
          reject(error);
        });
      })
      .catch(() => {
        reject("Error getUserInformation");
      });
    });
  }

  setUserActions(){
    this.storage.get("userActions")
    .then((userActions:Action[]) => {
      if(userActions !== null){
        this.webservice.setUserActions(userActions).subscribe(result => {
          if(result){
            this.storage.remove("userActions");
          }
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/user-information/user-information.ts